import { useState } from 'react'
import Button from '../../common/Button'
import classes from './ExpandCell.module.css'

export default function ExpandCell({children, initialText}) {

    const [expand, setExpand] = useState(false)
    function expandDrwaerHandler() {
        setExpand(prev => prev = !prev)
    }

    function mouseEnterHandler() {
        setExpand(true)
    }
    function mouseLeaveHandler() {
        setExpand(false)
    }

    return <div className={`${classes.container} ${expand ? classes.expanded : ''}`} onMouseEnter={mouseEnterHandler} onMouseLeave={mouseLeaveHandler}>
        {initialText} 
        {/* <Button click={expandDrwaerHandler} btnStyle={'btn_simple'}><i className='ti ti-chevron-down'></i></Button> */}
        {expand && <div className={classes.drawer}>
            {children}
        </div>}
    </div>
}